import { type Chart, type Plugin } from "chart.js";
import { set } from "lodash";
import { type ChartJSOrUndefined } from "react-chartjs-2/dist/types";

export const CHART_DATA_MANAGER_ID = "chartDataManager";

export type ChartDataManagerPluginOptions = {
  data: { datasets: any[] };
};

export const chartDataManagerPlugin: Plugin = {
  id: CHART_DATA_MANAGER_ID,
};

export const getChartData = (
  chart: Chart<any>,
): ChartDataManagerPluginOptions =>
  chart.config.options.plugins[CHART_DATA_MANAGER_ID];

export const setChartData = (
  chart: ChartJSOrUndefined | null,
  chartDataManager: ChartDataManagerPluginOptions,
) => {
  if (!chart) {
    return;
  }
  set(
    chart,
    `config.options.plugins.${CHART_DATA_MANAGER_ID}`,
    chartDataManager,
  );
  chart.update();
};
